import {ConsumerComplaintDocumentModel} from "@/models/consumer_complaint/ConsumerComplaintDocumentModel.js";

export class AdminConsumerComplaintModel {
    constructor(data = {}) {
        this.complaintId = data.complaintId ?? null;
        this.internalId = data.internalId ?? null;
        this.signatureDate = data.signatureDate ?? null;
        this.healthInsuranceCompany = data.healthInsuranceCompany ?? null;
        this.patientInsuranceId = data.patientInsuranceId ?? null;
        this.typeOfCoverage = data.typeOfCoverage ?? null;
        this.patientName = data.patientName ?? null;
        this.signature = data.signature ?? false;
        this.relationshipToPatient = data.relationshipToPatient ?? null;
        this.complaintStatus = data.complaintStatus ?? 'Pending Information Insurance';
        this.complaintOutcome = data.complaintOutcome ?? null;
        this.mdhInvestigator = data.mdhInvestigator ?? null;
        this.complaintCategory = data.complaintCategory ?? null;
        this.documents = data.documents ?? null;
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
    }
}
